import React, { createContext, useContext, useEffect, useState } from "react";
import constants from "../constants";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState(constants.LANGUAGE.DEFAULT);
    const [isInternalChange, setIsInternalChange] = useState(true);

    useEffect(() => {
        document.querySelector("html").setAttribute('lang', language === constants.LANGUAGE.SWEDISH ? 'sv-SE' : 'en-GB');
    }, [language]);

    useEffect(() => {
        const handleMessage = (e) => {
            const receivedLanguage = e.data?.language ?? null;
            const isValidLanguage = (receivedLanguage) ? Object.values(constants.LANGUAGE).includes(receivedLanguage) : false;

            if (isValidLanguage) {
                setIsInternalChange(false);
                setLanguage(receivedLanguage);
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    return (
        <LanguageContext.Provider value={{ language, setLanguage, isInternalChange, setIsInternalChange }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}